import { REQUEST } from 'Stores'
import { CHANGE_NAME, CREATE_FOLDER,
  DELETE_FILE,
  GET_DRIVES_HOT_LOAD,
  GET_FILES_T0_DOWNLOAD_FOLDER,
  GET_ONE_DRIVE, GET_ONE_DRIVE_AND_BREAD, GET_PORTFOLIO, MOVE_ITEM,
  REMOVE_FILES_T0_DOWNLOAD_FOLDER,
  UPLOAD_FILE,
  UPLOAD_FOLDER } from './constants'

export function getOneDrive(payload) {
  return {
    type: REQUEST(GET_ONE_DRIVE),
    payload
  }
}

export function getOneDriveAndBread(payload) {
  return {
    type: REQUEST(GET_ONE_DRIVE_AND_BREAD),
    payload
  }
}

export function deleteItem(payload) {
  return {
    type: REQUEST(DELETE_FILE),
    payload
  }
}

export function changName(payload) {
  return {
    type: REQUEST(CHANGE_NAME),
    payload
  }
}

export function createFolder(payload) {
  return {
    type: REQUEST(CREATE_FOLDER),
    payload
  }
}

export function moveItem(payload) {
  return {
    type: REQUEST(MOVE_ITEM),
    payload
  }
}

export function uploadFile(payload) {
  return {
    type: REQUEST(UPLOAD_FILE),
    payload
  }
}

export function getDrivesHotLoad(payload, callback) {
  return {
    type: REQUEST(GET_DRIVES_HOT_LOAD),
    payload,
    callback
  }
}

export function getPortfolio(payload) {
  return {
    type: REQUEST(GET_PORTFOLIO),
    payload
  }
}

export function getFilesToDownloadFolder(payload) {
  return {
    type: REQUEST(GET_FILES_T0_DOWNLOAD_FOLDER),
    payload
  }
}

export function removeFilesToDownloadFolder() {
  return {
    type: REQUEST(REMOVE_FILES_T0_DOWNLOAD_FOLDER)
  }
}

export function uploadFolder(payload) {
  return {
    type: REQUEST(UPLOAD_FOLDER),
    payload
  }
}
